import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { apiFetch } from '@/hooks/useQuery/helpers'
import { useUser } from '@/context/UserProvider';

interface Duration {
  id: string;
  duration: number;
  isValidBookingDuration: boolean;
  durationValidityCode?: string;
}

interface BookingDurationsQueryParams {
  propertyId: string;
  unitId: string;
  fromDate: string;
  maxDuration: number;
}

export function useQueryBookingDurations (
  { propertyId, unitId, fromDate, maxDuration }: BookingDurationsQueryParams,
  options?: UseQueryOptions<Duration[]>
) {
    const minNights = 3;
    const filteredProductMarket = 'ukcottages';
    const { user } = useUser()
    const productMarkets = user?.attributes.productMarkets ?? []    
    const queryKey = ['booking-durations', propertyId, unitId, fromDate, maxDuration]
    const shouldFilterDurations = productMarkets.some(
          productMarket => productMarket.trim().toLowerCase() === filteredProductMarket
        )
    const queryFn = async () => {
        const params = new URLSearchParams()
        let url = `/v1/properties/${propertyId}/bookings/owner/durations/bookability`

        params.append('unitId', unitId)
        params.append('fromDate', fromDate)
        params.append('maxDuration', maxDuration.toString())

        url += `?${params.toString()}`

        const durations: Duration[] = await apiFetch(url)

        return shouldFilterDurations 
            ? durations.filter(d => d.duration >= minNights)
            : durations
      }

  return useQuery<Duration[]>(queryKey, queryFn, {
    cacheTime: 0,
    ...options
  })
}
